export interface IDSSForm {
    formId       : string;
    title        : string;
    section      : "MENTAL_HEALTH" | "PHYSICAL_HEALTH";
    dimension    : ScoreKey;
    feedback_0   : string;
    feedback_60  : string;
    feedback_80  : string;
    content_0    : string;
    content_60   : string;
    content_80   : string;
    value       ?: number;
    last_updated?: Date;
}

export type ScoreKey =
    | "exposure"
    | "justice"
    | "support"
    | "demands"
    | "control"
    | "backPain"
    | "upperExtremities";

export type IFormValues = {
    [key in ScoreKey]: {
        score: number;
        date: Date;
    };
};

export const DimensionMapper: { [key: string]: ScoreKey } = {
    EXPOSURE: "exposure",
    JUSTICE: "justice",
    SUPPORT: "support",
    DEMANDS: "demands",
    CONTROL: "control",
    LOW_BACK_PAIN: "backPain",
    UPPER_BACK_PAIN: "upperExtremities"
};
